<template>
    <PageGroup>
        <router-view />
    </PageGroup>
</template>

<script>
    import PageGroup from 'source/components/_generics/layouts/PageGroup.vue';
    export default {
        name: 'TagsPageGroup',
        components: { PageGroup }
    };
</script>

<style lang="scss" scoped>

</style>
